import Dashboard from 'domain/entity/dashboard';
import { Result } from 'domain/types';
import DuplicateDashboardClient from 'use-case/dashboard/duplicate/duplicateDashboardClient';
import DuplicateDashboardCriteria from 'use-case/dashboard/duplicate/duplicateDashboardCriteria';

export type DuplicateDashboardResult = Result<Dashboard>;
export type DuplicateDashboard = (criteria: DuplicateDashboardCriteria) => Promise<DuplicateDashboardResult>;

export default (duplicateDashboardClient: DuplicateDashboardClient): DuplicateDashboard => (
    criteria: DuplicateDashboardCriteria
): Promise<DuplicateDashboardResult> => duplicateDashboardClient(criteria);
